import React from "react";
// REDUX
import { useSelector } from "react-redux";
// COMPONENTS
import GroupsTable from "./GroupsTable";
import GroupDeleteModal from "./GroupDeleteModal";
import GroupsDrawer from "./GroupsDrawer";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const GroupsPage = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);
  const { theme } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div>
      {hasPermission(Permission.ViewEdgeManagementGroups, permissionSet ?? []) ? (
        <div className={`layout__contentPage__${theme}`}>
          <GroupsTable />
          <GroupDeleteModal />
          <GroupsDrawer />
        </div>
      ) : (
        <UnauthorizedPage />
      )}
    </div>
  );
};

export default GroupsPage;
